export enum EAgentTypes {
  Agency = 'agency',
  Company = 'company',
  Agent = 'agent',
}
